<template>
  <v-list v-if="notificationsList.length != 0" subheader two-line>
    <v-list-item
      v-for="notification in notificationsList"
      :key="notification.id"
      id="notification-item-dashboard"
      @click="
        $router.push({
          name: 'NotificationDetailView',
          params: {
            id: notification.id,
          },
        })
      "
    >
      <v-chip
        style="width: 130px"
        class="white--text justify-center"
        :color="getNotificationStatus(notification).color"
      >
        <v-icon :class="getNotificationStatus(notification).color" dark>
          {{ getNotificationType(notification).icon }}
        </v-icon>
        <span class="ml-1">
          {{ $t(getNotificationStatus(notification).status) }}
        </span>
      </v-chip>

      <!-- Si el estado es Urgente, añadimos icono + tooltip -->
      <v-tooltip
        top
        :content-class="
          getNotificationStatus(notification).icon?.name
            ? 'tooltip-disclaimer'
            : ''
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            :class="
              getNotificationStatus(notification).icon?.name ? 'ml-1' : 'ml-0'
            "
            :color="getNotificationStatus(notification).icon?.color"
            default
          >
            {{ getNotificationStatus(notification).icon?.name }}
          </v-icon>
        </template>
        <span v-html="tooltipDisclaimerPanel()"></span>
      </v-tooltip>

      <div class="ml-2 mr-2 subtitle">
        {{ $d(notification.fecha_puesta_disposicion, 'i18nDate') }}
      </div>
      <v-list-item-content class="text-left align-self-start">
        <v-list-item-title>
          <b>
            {{ notification.nombre_titular }}
          </b>
        </v-list-item-title>
        <v-list-item-title>
          {{ notification.nombre_organismo_emisor }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ notification.nombre_organismo_emisor_raiz }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-container v-else style="text-align: center">
    <b>
      <span> {{ $t('emptyTypeNotificationList') }} </span>
    </b>
  </v-container>
</template>

<script>
import {
  getNotificationStatus,
  getNotificationType,
} from '@/services/notification-service'

export default {
  props: {
    notificationsList: {
      type: Array,
    },
  },
  methods: {
    getNotificationStatus(notification) {
      return getNotificationStatus(notification)
    },
    getNotificationType(notification) {
      return getNotificationType(notification)
    },
    /**
     * Return the name of the company. If it is to long it adds '...'
     * @param {String} name Name of the company.
     */
    companyName(name) {
      return name.length > 15 ? name.substring(0, 13) + '...' : name
    },
    tooltipDisclaimerPanel() {
      // Mostrar en un tooltip multilinea
      const line1 = this.$t('disclaimerExpiration.panel.line1')
      const line2 = this.$t('disclaimerExpiration.panel.line2')
      const line3 = this.$t('disclaimerExpiration.panel.line3')
      const line4 = this.$t('disclaimerExpiration.panel.line4')
      const line5 = this.$t('disclaimerExpiration.panel.line5')

      // Unir las lineas con saltos de linea para mostrar un tooltip multilinea
      return `
        <div style="padding: 6px 8px; margin-top: 4px; text-align: center;">
          ${line1}<br>
          ${line2}<br>
          ${line3}
        </div>
        <div style="border: 1px solid; border-radius: 4px; padding: 6px 8px; margin-top: 6px; background-color: #b03936">          
          <span style="color: #ffffff; font-weight: bold; font-size: 1.1em; display: block;">${line4}</span>
          <span style="color: #ffffff; font-weight: bold; font-size: 1.1em; display: block;">${line5}</span>
        </div>
      `
    },
  },
}
</script>

<style lang="scss" scoped>
/* tooltip de disclaimer: color fondo personalizado y eliminar la transparencia */
.tooltip-disclaimer {
  background-color: rgba(97, 97, 97, 1) !important; /* opaco */
  opacity: 1 !important; /* sin transparencia */
  color: #ffffff; /* texto base legible */
}
</style>
